
const digest = '32f5143eca457bf6e91fbae6f59f422f82863a0c35a50b0283ccbe7a48440df5';
const classes = {"wrapper":"_wrapper_a76us_1","title":"_title_a76us_8"};
const css = `._wrapper_a76us_1 {
  background-color: #fff;
  padding: 24px;
  border: 1px solid #eaedf3;
  height: 100%;
  overflow-y: auto;
}
._wrapper_a76us_1 ._title_a76us_8 {
  font-weight: 600;
  margin-bottom: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  